import styled from '@emotion/styled'

export const LanguageSwitcherWrapper = styled.div``

export const IconWrapper = styled.figure`
  display: flex;
`
